<template>
    <div class="payment-method-item" :class="{ 'payment-method-item--selected': isSelectedPaymentMethod }"
         @click="paymentMethodClicked()">

        <img class="payment-method-item__selected-icon" src="@/assets/icon-selected-on.svg"
             v-if="isSelectedPaymentMethod">
        <img class="payment-method-item__selected-icon payment-method-item__selected-icon--off"
             src="@/assets/icon-selected-off.svg" v-else>

        <img class="payment-method-item__brand" :src="getBrandUrl" :alt="pm.card.brand">

        <div class="payment-method-item__card-number">**** **** **** {{ pm.card.last4 }}</div>
        <div class="payment-method-item__expire-on">{{ pm.card.exp_month }}/{{ pm.card.exp_year }}</div>
        <span class="payment-method-item__default" v-if="isDefaultPaymentMethod">{{ $t('pages.checkout.paymentmethoditem_default') }}</span>
        <b-dropdown variant="link" class="payment-method-item__options" toggle-class="text-decoration-none" no-caret right
                    @hidden="dropdownOptionsHidden">
            <template slot="button-content">•••<span class="sr-only">{{ $t('pages.checkout.paymentmethoditem_options') }}</span></template>
            <b-dropdown-item href="#" @click.stop="setDefaultClicked()" v-if="! isDefaultPaymentMethod">{{ $t('pages.checkout.paymentmethoditem_option_set_as_default') }}</b-dropdown-item>
            <b-dropdown-item href="#">
                <b-button variant="text-link" class="text-danger p-0"
                          v-if="removeConfirmRequested" @click.stop="removeClicked()">{{ $t('pages.checkout.paymentmethoditem_option_remove_confirm') }}</b-button>
                <span v-else @click.stop="setRemoveConfirmRequested()">{{ $t('pages.checkout.paymentmethoditem_option_remove') }}</span>
            </b-dropdown-item>
        </b-dropdown>
    </div>
</template>


<script>
    export default {
        props: {
            pm: {
                type: Object,
                required: true
            },

            defaultPaymentMethodId: {
                type: String,
                required: false
            },

            selectedPaymentMethodId: {
                type: String,
                required: false
            },
        },

        data() {
            return {
                removeConfirmRequested: false
            }
        },

        computed: {
            getBrandUrl() {
                return require('@/assets/card-brands/' + this.pm.card.brand + '.png')
            },

            isDefaultPaymentMethod() {
                return this.pm.id === this.defaultPaymentMethodId
            },

            isSelectedPaymentMethod() {
                return this.pm.id === this.selectedPaymentMethodId
            },
        },

        methods: {
            setRemoveConfirmRequested() {
                this.removeConfirmRequested = true
                setTimeout(() => this.removeConfirmRequested = false, 2000)
            },

            dropdownOptionsHidden() {
                this.removeConfirmRequested = false
            },

            paymentMethodClicked() {
                this.$emit('paymentmethod-selected', this.pm.id)
            },

            setDefaultClicked() {
                this.$emit('set-default-clicked', this.pm.id)
            },

            removeClicked() {
                this.$emit('remove-clicked', this.pm.id)
            }
        }
    }
</script>
